import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrigineDemande } from 'src/app/shared/models/origineDemande';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';

@Injectable({
	providedIn: 'root'
})
export class OrigineDemandeService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllOrigineDemande(): Observable<OrigineDemande[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.origineDemandeUrl}/all`,
			'getAllOrigineDemande'
		);
	}

	importOrigineDemande(file: File): Observable<ImportResponse> {
		const formData: FormData = new FormData();
		formData.append('file', file, 'origineDemande.csv');
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.origineDemandeUrl}/import`,
			`importOrigineDemande`,
			formData
		);
	}

	getOrigineDemandeById(id: number): Observable<OrigineDemande> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.origineDemandeUrl}/get/${id}`,
			'getOrigineDemandeById'
		);
	}

	updateOrigineDemande(origineDemande: OrigineDemande): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.origineDemandeUrl}/update/${origineDemande.id}`,
			'updateOrigineDemande',
			origineDemande
		);
	}

	addOrigineDemande(origineDemande: OrigineDemande): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.origineDemandeUrl}/add`,
			'addOrigineDemande',
			origineDemande
		);
	}

	deleteOrigineDemande(origineDemandeId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.origineDemandeUrl}/delete/${origineDemandeId}`,
			`deleteOrigineDemande`
		);
	}
}
